import { FC } from "react";
import { Box, FormControl, Grid, IconButton, Input, InputLabel, Select, Tooltip } from "@mui/material";
import CheckAttr from "../../../../utils/CheckAttr";
import { OtherArticle } from "../AddBudgetReforecastForm";
import { DataRef } from "../../../../types/DataRef";
import ClearIcon from '@mui/icons-material/Clear';

interface OtherArticleRowProps {
    index: number;
    dataPaysInAssociations: DataRef[];
    dataBusinessUnits: DataRef[];
    dataTypes: DataRef[];
    row: OtherArticle;
    articlesAutres: OtherArticle[];
    otherArticleErrorInput: string[];
    handleChangeArticleAutre: (e: any, i: number) => void;
    handleRemoveRow: (i: number) => void;
}

const OtherArticleRow: FC<OtherArticleRowProps> = ({
    index,
    dataPaysInAssociations,
    dataBusinessUnits,
    dataTypes,
    row,
    articlesAutres,
    otherArticleErrorInput,
    handleChangeArticleAutre,
    handleRemoveRow
}) => {

    const handleChange = (e: any) => {
        handleChangeArticleAutre(e, index);
    };

    return (
        <Grid container columnSpacing={2} columns={{ xs: 6, sm: 12, md: 12 }} sx={{ my: (index > 0) ? 2 : 0 }}>
            <Grid item xs={6} sm={2.85} md={2.85}>
                <FormControl
                    fullWidth
                    variant="standard"
                    size="small"
                >
                    <InputLabel
                        htmlFor="pays_id"
                        color="warning"
                        shrink={CheckAttr(articlesAutres[index]?.pays_id)}
                    >
                        Pays
                    </InputLabel>
                    <Select
                        id="pays_id"
                        native
                        color="warning"
                        size="small"
                        value={articlesAutres[index]?.pays_id}
                        error={otherArticleErrorInput.includes(`pays_id_${index}`)}
                        onChange={handleChange}
                        label="Pays"
                        inputProps={{
                            name: "pays_id",
                        }}
                    >
                        <option value=""></option>
                        {dataPaysInAssociations.map((secteur) => (
                            <option key={secteur?.id} value={secteur?.id}>
                                {secteur?.libelle}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={6} sm={2.85} md={2.85}>
                <FormControl
                    fullWidth
                    variant="standard"
                    size="small"
                >
                    <InputLabel
                        htmlFor="bu_id"
                        color="warning"
                        shrink={CheckAttr(articlesAutres[index]?.bu_id)}
                    >
                        Business unit
                    </InputLabel>
                    <Select
                        id="bu_id"
                        native
                        color="warning"
                        size="small"
                        value={articlesAutres[index]?.bu_id}
                        error={otherArticleErrorInput.includes(`bu_id_${index}`)}
                        onChange={handleChange}
                        label="Business unit"
                        inputProps={{
                            name: "bu_id",
                        }}
                    >
                        <option value=""></option>
                        {dataBusinessUnits.map((bu) => (
                            <option key={bu?.id} value={bu?.id}>
                                {bu?.libelle}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={6} sm={2.85} md={2.85}>
                <FormControl
                    fullWidth
                    variant="standard"
                    size="small"
                    color="warning"
                >
                    <InputLabel
                        htmlFor="component-simple"
                        shrink={CheckAttr(articlesAutres[index]?.article_libelle)}
                    >
                        Désignation
                    </InputLabel>
                    <Input
                        id="component-simple"
                        autoComplete="off"
                        name="article_libelle"
                        error={otherArticleErrorInput.includes(`article_libelle_${index}`)}
                        value={articlesAutres[index]?.article_libelle}
                        onChange={handleChange}
                    />
                </FormControl>
            </Grid>

            <Grid item xs={6} sm={2.85} md={2.85}>
                <FormControl
                    fullWidth
                    variant="standard"
                    size="small"
                >
                    <InputLabel
                        htmlFor="type_id"
                        color="warning"
                        shrink={CheckAttr(articlesAutres[index]?.type_id)}
                    >
                        Type
                    </InputLabel>
                    <Select
                        id="type_id"
                        native
                        color="warning"
                        size="small"
                        value={articlesAutres[index]?.type_id}
                        error={otherArticleErrorInput.includes(`type_id_${index}`)}
                        onChange={handleChange}
                        label="Type"
                        inputProps={{
                            name: "type_id",
                        }}
                    >
                        <option value=""></option>
                        {dataTypes.map((type) => (
                            <option key={type?.id} value={type?.id}>
                                {type?.libelle}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={6} sm={1.5} md={0.6}>
                <Box display="flex" justifyContent="center">
                    <Tooltip title="Supprimer ce ligne">
                        <IconButton
                            aria-label="delete"
                            size="small"
                            disabled={row?.has_budget}
                            onClick={() => handleRemoveRow(index)}
                        >
                            <ClearIcon fontSize="small" sx={{ mt: 2 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Grid>
        </Grid>
    );
};

export default OtherArticleRow;
